document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('cfp-form');
  if (!form) return;

  const qtyInput = form.querySelector('.qty-input');
  const qtyContainer = form.querySelector('.cfp__quantity-wrapper');
  const minusBtn = qtyContainer.querySelector('.qty-btn.minus');
  const btnPrice = form.querySelector('.btn-price');
  const optionItems = form.querySelectorAll('.cfp__option-item');

  function updatePrice() {
    if (!btnPrice) return;
    const selectedOption = form.querySelector('input[name="selling_plan_select"]:checked');
    if (!selectedOption) return;
    
    const optionItem = selectedOption.closest('.cfp__option-item');
    const priceElement = optionItem.querySelector('.cfp__option-price .price');
    const priceText = priceElement.textContent;
    
    // Відображаємо ціну на кнопці (тільки суму, без /month)
    btnPrice.textContent = priceText.split('/')[0].trim();
  }

  // Функція для оновлення стану кнопки minus
  function updateMinusButton() {
    const val = parseInt(qtyInput.value);
    if (minusBtn) {
      minusBtn.disabled = (val <= 1);
    }
  }

  // Логіка кнопок +/-
  form.addEventListener('click', (e) => {
    if (e.target.closest('.qty-btn')) {
      const btn = e.target.closest('.qty-btn');
      let val = parseInt(qtyInput.value);
      if (btn.classList.contains('plus')) {
        qtyInput.value = val + 1;
      } else if (val > 1) {
        qtyInput.value = val - 1;
      }
    }
    updateMinusButton();
  });

  // Логіка підписки (Subscription)
  form.addEventListener('change', (e) => {
    if (e.target.name === 'selling_plan_select') {
      const hiddenSellingPlan = form.querySelector('input[name="selling_plan"]');
      if (hiddenSellingPlan) {
        hiddenSellingPlan.value = e.target.value;
        // Triggering change event to let Shopify scripts know about the update
        hiddenSellingPlan.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Оновлюємо активний клас
      optionItems.forEach(item => item.classList.remove('active'));
      const activeItem = e.target.closest('.cfp__option-item');
      activeItem.classList.add('active');

      if (e.target.value !== "") {
        // Якщо обрана підписка - ставимо кількість 1 і блокуємо
        qtyInput.value = 1;
        updateMinusButton();
        qtyContainer.style.opacity = '0.5';
        qtyContainer.style.pointerEvents = 'none';
      } else {
        // Якщо одноразова покупка - розблоковуємо
        qtyContainer.style.opacity = '1';
        qtyContainer.style.pointerEvents = 'all';
      }
      
      updatePrice();
    }
  });
  
  // Ініціалізація ціни та активного стану
  const initialChecked = form.querySelector('input[name="selling_plan_select"]:checked');
  if (initialChecked) {
    const hiddenSellingPlan = form.querySelector('input[name="selling_plan"]');
    if (hiddenSellingPlan) {
      hiddenSellingPlan.value = initialChecked.value;
    }
  }
  updatePrice();
  
  // Додаткова перевірка активного стану при завантаженні
  const checkedInput = form.querySelector('input[name="selling_plan_select"]:checked');
  if (checkedInput && checkedInput.value !== "") {
    qtyInput.value = 1;
    qtyContainer.style.opacity = '0.5';
    qtyContainer.style.pointerEvents = 'none';
  }
  updateMinusButton();
});
